import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Text } from '@radix-ui/themes';
import { CommonTooltip } from 'components/common/tooltip';
import { VideoHelper } from 'lib_ts/classes/video.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IVideo } from 'lib_ts/interfaces/i-video';
import { first } from 'lodash';
import { useMemo } from 'react';

export const VideoErrorsIcon = (props: { video: IVideo }) => {
  const errors = useMemo(
    () => VideoHelper.getErrors(props.video),
    [props.video]
  );

  const firstError = first(errors);

  if (!firstError) {
    return null;
  }

  return (
    <CommonTooltip
      text={firstError.msg}
      trigger={
        <Text color={RADIX.COLOR.NEUTRAL}>
          <ExclamationTriangleIcon style={{ marginTop: RADIX.ICON.TABLE_MT }} />
        </Text>
      }
    />
  );
};
